import { render, staticRenderFns } from "./VeteranDetail.vue?vue&type=template&id=2bb118fa&"
import script from "./VeteranDetail.vue?vue&type=script&lang=js&"
export * from "./VeteranDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports